import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, Fragment as _Fragment, unref as _unref, renderList as _renderList, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "w-full flex-grow overflow-hidden text-gray-theme-500"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["srcdoc"]
const _hoisted_5 = {
  key: 1,
  class: "w-full flex-grow overflow-hidden text-gray-theme-500"
}
const _hoisted_6 = ["innerHTML"]

import { httpService } from '@/utils';
import { onMounted, ref, nextTick } from 'vue';
import { useToggle } from '@vueuse/core';
import {
	ConversationEmailMessage,
	useConversations,
	useMessages,
	ConversationMessage,
	MessageDetails
} from '../../composition';
import MediaList from './MediaList.vue';
import ChildEmail from './ChildEmail.vue';
import { useContacts } from '@/contacts';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailFullMessage',
  props: {
    message: null,
    messageDetails: null
  },
  setup(__props: any) {

const props = __props as {
	message: ConversationEmailMessage;
	messageDetails?: MessageDetails;
};



const { selectedConversation } = useConversations();
const { selectedContact } = useContacts();
const { setMessageDetailsChildren } = useMessages();

const height = ref('0px');
const iframeRef = ref<HTMLIFrameElement>();
const loaded = ref(false);

async function setHeight() {
	await nextTick();
	height.value = `${
		iframeRef.value!.contentWindow!.document.body
			.scrollHeight + 30
	}px`;
	setTimeout(() => {
		loaded.value = true;

		iframeRef
			.value!.contentWindow?.document.querySelectorAll(
				'a'
			)
			.forEach((a) => {
				a.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopPropagation();
					const linkHref = a.getAttribute('href');

					if (!linkHref) {
						return;
					}

					window.open(linkHref, '_blank');
				});
			});

		iframeURLChange(
			iframeRef.value!,
			function (newURL: string) {
				console.log('URL changed:', newURL);
			}
		);
	}, 50);
}

const [childrenLoading, setChildrenLoading] = useToggle();

onMounted(async () => {
	console.log(props.message);
	if (
		props.message.sender ||
		(!props.message.content.body_html &&
			!!props.message.content.body_plain)
	) {
		loaded.value = true;
		iframeURLChange(
			iframeRef.value!,
			function (newURL: string) {
				console.log('URL changed:', newURL);
			}
		);
	}

	if (
		!props.message.children_count ||
		props.message.children_count ===
			props.messageDetails?.children?.length
	) {
		return;
	}

	setChildrenLoading(true);

	const children = await httpService.get<
		ConversationMessage[]
	>(
		`company/conversations/${
			selectedConversation.value!.id
		}/messages/${props.message.uid}/thread`
	);

	setMessageDetailsChildren(children.slice().reverse());
	setChildrenLoading(false);
});

function iframeURLChange(
	iframe: HTMLIFrameElement,
	callback: any
) {
	if (!iframe) {
		return;
	}

	let lastDispatched: any = null;

	const dispatchChange = function () {
		const newHref = iframe.contentWindow?.location.href;

		if (newHref !== lastDispatched) {
			callback(newHref);
			lastDispatched = newHref;
		}
	};

	const unloadHandler = function () {
		// Timeout needed because the URL changes immediately after
		// the `unload` event is dispatched.
		setTimeout(dispatchChange, 0);
	};

	function attachUnload() {
		// Remove the unloadHandler in case it was already attached.
		// Otherwise, there will be two handlers, which is unnecessary.
		iframe.contentWindow?.removeEventListener(
			'unload',
			unloadHandler
		);
		iframe.contentWindow?.addEventListener(
			'unload',
			unloadHandler
		);
	}

	iframe.addEventListener('load', function () {
		attachUnload();

		// Just in case the change wasn't dispatched during the unload event...
		dispatchChange();
	});

	attachUnload();
}

const expandedChild = ref(-1);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["w-full bg-white relative py-4 px-10 mx-auto transition flex flex-col gap-6", loaded.value ? 'opacity-100' : 'opacity-0'])
    }, [
      (__props.message.content.body_html)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (__props.message.sender)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", {
                    innerHTML: __props.message.content.body_html
                  }, null, 8, _hoisted_3)
                ]))
              : (_openBlock(), _createElementBlock("iframe", {
                  key: 1,
                  ref_key: "iframeRef",
                  ref: iframeRef,
                  onLoad: setHeight,
                  class: "w-full flex-grow overflow-hidden",
                  style: _normalizeStyle({ height: height.value }),
                  srcdoc: `<style>html { font-family: Avenir, sans-serif; color: rgb(60, 65, 73); }</style>${__props.message.content.body_html}`
                }, null, 44, _hoisted_4)),
            _createVNode(MediaList, {
              media: __props.message.media
            }, null, 8, ["media"])
          ], 64))
        : (__props.message.content.body_plain)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                innerHTML: __props.message.content.body_plain
              }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
      (
					!_unref(childrenLoading) &&
					__props.messageDetails?.children?.length
				)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(__props.messageDetails.children, (child, i) => {
            return (_openBlock(), _createBlock(ChildEmail, {
              key: i,
              email: child,
              contact: _unref(selectedContact),
              isExpanded: i === expandedChild.value,
              onExpand: ($event: any) => (expandedChild.value = i),
              onClose: _cache[0] || (_cache[0] = ($event: any) => (expandedChild.value = -1))
            }, null, 8, ["email", "contact", "isExpanded", "onExpand"]))
          }), 128))
        : _createCommentVNode("", true),
      (_unref(childrenLoading))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, _renderList(3, (n) => {
            return _createElementVNode("div", {
              key: n,
              class: "h-11 shadow-lg border border-solid skeleton-loading"
            })
          }), 64))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})